import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewContainerRef,
  ViewChild, ComponentFactoryResolver, ViewRef
} from '@angular/core';
import { Store } from '@ngrx/store';
import {
  FormAttributes,
  FormAttribute
} from '@eview/core/domain/form/form-attribute';
import { FilterCriteria } from '@eview/core/domain/filters/filterCriteria';
import { FilterHelpers } from '@eview/core/domain/filters/filters.helper';
import {
  ListPostOptions,
  Posts,
  PostStatus
} from '@eview/core/domain/post/post';
import { Form, sortFormsDefaultFirst } from '@eview/core/domain/form/form';
import { selectMap } from '@eview/core/store/selectors/map.selector';
import { PostService } from '@eview/core/domain/post/post.service';
import { GetConfig } from '@eview/core/store/actions/config.actions';
import { selectConfig } from '@eview/core/store/selectors/config.selector';
import { selectTags } from '@eview/core/store/selectors/tags.selector';
import { ConfigService } from '@eview/core/config/config.service';
import { selectFormAttributes } from '@eview/core/store/selectors/form-attributes.selector';
import { AppState } from '@eview/core/store/states/app.state';
import { environment } from '@eview/core/environments/environment';
import { isEmpty } from 'lodash';
import { Subscription } from 'rxjs';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ngbDateCustomFmt } from '../../shared/ngb-date-custom-fmt';
import { ToastType } from '../../toast/toast.component';
import { ToastService } from '../../toast/toast.service';
import { FlexMonsterConfig as ReportJson } from './report-format';
import { Tags } from '@eview/core/domain/tags/tag';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FlexmonsterComponent } from './flexmonster.component';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ListFormAttributes } from '@eview/core/store//actions/form-attributes.actions';
import { selectForms } from '@eview/core/store/selectors/forms.selector';
import { Permission } from '@eview/core/auth/permission';
import { AuthHelpers } from '@eview/core/auth';
import { ExportPost } from '@eview/core/store/actions/export.actions';
import { ExportDownloadService } from '@eview/core/domain/export/export-download.service';
import { openExportColumnsModal } from '../../shared/export-columns-modal/open-export-columns-modal';
import { CatalogFacade } from '@eview/core/store/facades/catalog.facade';
@Component({
  selector: 'eview-post-filters',
  templateUrl: 'post-filters.component.html',
  styleUrls: ['post-filters.component.scss'],
  providers: [{ provide: NgbDateParserFormatter, useClass: ngbDateCustomFmt }]
})
export class PostFiltersComponent implements OnInit, OnDestroy {
  @ViewChild('chartsContainer', { static: true }) private fmpivot: any;
  private subs: Subscription;
  private formAttributes: FormAttributes;
  public filterCategory: FormAttribute[];
  protected isDisabled: boolean = true;
  public showChartsBtn: boolean = false;
  protected reportIndex: number = 0;
  protected regionalMapData: any = [];
  protected reportTitle: string = '';
  protected mapRegions: any[] = [];
  protected showReport: boolean = false;
  protected filterCriteria: FilterCriteria[] = [];
  public graphType: number = 4;
  protected updatedReport: any = [];
  protected tags: Tags[] = [];
  protected isReportChecked: number = 0;
  protected isShowMapClicked: boolean = false;
  protected formList: Form[] = [];
  protected formId: number = environment.form.id;
  private requestOptions: ListPostOptions = {
    status: PostStatus.All,
    created_after: null,
    created_before: null,
    formId: environment.form.id
  };
  posts: Posts = { count: 0, results: [] };
  mapReports: any = ReportJson;
  configFilters = [];
  viewRef: ViewRef[] = [];
  selectedFilters: any = [];
  protected environment = environment;
  maxDate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate()
  };
  AuthHelpers = AuthHelpers;
  Permission = Permission;
  constructor(
    private store: Store<AppState>,
    private configService: ConfigService,
    @Inject(ViewContainerRef) private viewContainerRef: ViewContainerRef,
    private toast: ToastService,
    private postService: PostService,
    private modalService: NgbModal,
    private exportDownload: ExportDownloadService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private translate: TranslateService,
    private catalog: CatalogFacade

  ) {
    this.subs = new Subscription();
    this.selectedFilters['formId'] = this.formId;
    toast.setViewContainerRef(viewContainerRef);
    const currentLang = this.translate.currentLang;
    this.mapReports.localization = `/assets/i18n/flexmonster-localization-${currentLang}.json`
  }
  ngOnInit() { 
    this.catalog.ensureTags();
    this.store.dispatch(new ListFormAttributes({ id: this.requestOptions.formId }));
    this.subs.add(
      this.translate.onLangChange.subscribe((langChangeEvent: LangChangeEvent) => {
        this.mapReports.localization = `/assets/i18n/flexmonster-localization-${langChangeEvent.lang}.json`
        this.resetFlexCharts();
        this.loadFlexchart();
      })
    )
    this.getFormFields();
    this.store.select(selectTags).subscribe((tags: any) => {
      tags.results.forEach(item => {
        if (item.type === 'type-of-incident') {
          this.tags[item.id] = item.tag;
        }
      });
    });

    this.subs.add(
      this.store.select(selectForms).subscribe((forms: any) => {
        this.formList = sortFormsDefaultFirst(
          forms.results.filter(form => !form.disabled)
        );
      })
    )

    this.store.select(selectMap).subscribe(map => {
      if (map) {
        this.mapRegions = map.regions;
      }
    });
    this.store.select(selectConfig).subscribe((config: any) => {
      if (!isEmpty(config)) {
        const filterData = config.results.filter(item => {
          return item.id === 'filters';
        });
        this.filterCriteria =
          filterData && filterData[0].criteria ? filterData[0].criteria : [];
        const result = filterData ? filterData[0].filters : [];

        for (let prop in result) {
          let obj = result[prop].value,
            values = [];
          for (let key in result[prop].value) {
            values.push({ id: key, name: obj[key] });
          }
          this.configFilters.push({
            key: prop,
            name: result[prop].label,
            values: values
          });
        }
      }
    });

  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  getFormFields() {
    this.subs.add(
      this.store.select(selectFormAttributes).subscribe((formAttributes) => {
        if (
          !formAttributes?.results?.length ||
          formAttributes.results[0]?.form_stage_id !== this.formId
        ) {
          return;
        }
        this.formAttributes = formAttributes;
        this.filterCategory = this.formAttributes.results.filter(
          item => item.type !== 'tags'
        );
      })
    );
  }

  private switchAnalysisForm(nextFormId: number): void {
    this.formId = nextFormId;
    this.selectedFilters['formId'] = nextFormId;
    this.requestOptions.formId = nextFormId;
    this.requestOptions.form = nextFormId;
    this.filterCategory = [];
    this.showReport = false;
    this.store.dispatch(new ListFormAttributes({ id: nextFormId }));
  }

  onFilterValueChanges(reportId) {
    const nextFormId = parseInt(reportId, 10);
    if (Number.isNaN(nextFormId) || nextFormId === this.formId) {
      return;
    }
    this.isDisabled = false;
    this.switchAnalysisForm(nextFormId);
  }

  onReportTypeChange(val) {
    const nextFormId = parseInt(val, 10);
    if (Number.isNaN(nextFormId) || nextFormId === this.formId) {
      return;
    }
    delete this.requestOptions.parent;
    this.switchAnalysisForm(nextFormId);
    // if (parseInt(val) === 2) {

    // } else {
    //   delete this.requestOptions.parent;
    // }
  }

  getSelectedFilters() {
    const { duration, fromdate, todate, formId } = this.selectedFilters;
    let request: FilterCriteria = {
      duration: duration
    };
    if (duration == 4) {
      request.startDate = fromdate;
      request.endDate = todate;
    }
    if (this.isReportChecked == 2) {
      request.isReport = true;
    }
    request.formId = formId;
    return request;
  }

  onCustomizeToolbar(toolbar, id) {
    let tabs = toolbar.getTabs();
    let title = this.translate.instant('REMOVE');
    let map = this.translate.instant('MENU_MAP');
    toolbar.getTabs = function () {
      // add new tab
      const mapTab = [
        {
          id: 'fm-tab-maptab',
          title: map,
          handler: 'onShowMap',
          icon:
            '<img width="36" height="36" style="border: 1px solid darkgrey;padding: 2px;margin-bottom: 7px;border-radius: 5px;" src="/assets/images/world.png" />'
        },
        {
          id: "fm-tab-maptab",
          title: title,
          handler: "onDeleteReport",
          icon: '<img width="36" height="36" style="border: 1px solid darkgrey;padding: 2px;margin-bottom: 7px;border-radius: 5px;" src="/assets/images/cross-remove-sign.svg" />'
        }
      ];
      tabs = tabs.slice(3, 12);
      tabs.splice(4, 0, mapTab[1]);
      return tabs;
    };
    toolbar.onDeleteReport = () => {
      this.removeFlexChart(id);
    }
  }

  onShowMap() {
    this.isShowMapClicked = true;
    this.regionalMapData = FilterHelpers.GetFormattedMapData(this.posts);
  }

  onHideMap() {
    this.isShowMapClicked = false;
  }

  onReportReady(data: any) {
    if (data) {
      this.updatedReport.push(data);
    }
  }

  onReportSaveClick(content) {
    this.modalService.open(content, { centered: true });
  }

  onSaveFilterClick() {
    const requestOption = this.getSelectedFilters();
    if (!isEmpty(this.updatedReport)) {
      let reportList = [];

      this.updatedReport.forEach(report => {
        const data = report.getReport();
        data.dataSource.data = '';
        reportList.push(data);
      });
      requestOption.reportConfig = reportList;
      requestOption.isMapShow = this.isShowMapClicked;
    }
    const reqBody = new Object();
    reqBody[this.reportTitle] = requestOption;
    this.modalService.dismissAll();
    this.configService.update('filters', reqBody).subscribe(results => {
      if (results) {
        this.store.dispatch(new GetConfig());
        this.selectedFilters = [];
        this.isDisabled = true;
        this.showReport = false;
        this.isReportChecked = 0;
        this.resetFlexCharts();
        this.reportTitle = '';
        this.toast.show(ToastType.Success, 'TOAST_FILTER_SAVED');
      }
    });
  }

  getFormattedData() {
    if (this.posts) {
      let processedData = (this.selectedFilters['formId'] === this.formId) ? FilterHelpers.GetAllReportColumns(this.mapRegions, this.filterCategory) : [];
      this.mapReports.dataSource.mapping = {
        ...this.mapReports.dataSource.mapping,
        ...processedData[0]
      };
      if (processedData !== undefined && processedData !== null) {
        this.posts.results.forEach(reportItem => {
          let params = {
            reportItem: reportItem,
            tags: this.tags,
            attributes: this.filterCategory,
            formId: this.selectedFilters['formId']
          }
          const individualItem = FilterHelpers.GetAllColumnData(params);
          processedData = [...processedData, ...individualItem];
        });
        this.mapReports.dataSource.data = [...processedData];
      }

   //   this.resetFlexCharts();
   //   this.loadFlexchart();
      setTimeout(() => {
         this.onShowMap()
     }, 20);
    }
  }

  createFlexComponent() {
    const factory = this.componentFactoryResolver.resolveComponentFactory(FlexmonsterComponent);
    const component = factory.create(this.fmpivot);
    const pivotComponent = <FlexmonsterComponent>component.instance;
    const viewRef = this.viewContainerRef.insert(component.hostView);
    this.viewRef.unshift(viewRef);
    return pivotComponent;
  }

  loadFlexchart() {
    const component = this.createFlexComponent();
    this.scrollWindow();
    component.mapReports = this.mapReports;
    component.reportIndex = this.reportIndex;
    component.beforetoolbarcreated.subscribe((result) => {
      this.onCustomizeToolbar(result.data, result.reportId);
    });
    component.ready.subscribe(($event) => {
      this.onReportReady($event);
    });
    component.removeReport.subscribe(($event) => {
      this.removeFlexChart($event);
    });
  }

  removeFlexChart(index: number) {
    if (this.viewRef && this.viewRef.length > 0) {
      this.viewRef[index].destroy();
    }
    delete this.updatedReport[index];
  }

  resetFlexCharts() {
    if (this.viewRef && this.viewRef.length > 0) {
      for (let index in this.viewRef) {
        this.viewRef[parseInt(index)].destroy();
      };
    }
    this.updatedReport = [];
  }

  async onExportClick() {
    const columns = this.exportDownload.buildColumnOptions(
      this.formAttributes?.results,
      this.formId
    );
    const selection = await openExportColumnsModal(this.modalService, columns);
    if (!selection) {
      return;
    }
    const formName =
      this.formList?.find(f => Number(f.id) === Number(this.formId))?.name || '';
    this.exportDownload.setPendingOptions({
      ...selection,
      documentName: this.exportDownload.buildReportDocumentName(formName)
    });
    this.toast.show(ToastType.Success, 'DOWNLOAD_MSG');
    const payload: ListPostOptions & { columns?: string } = {
      status: this.requestOptions.status,
      type: 'report',
      form: this.formId,
      columns: selection.columnKeys.join(',')
    };
    if (this.requestOptions.created_after) {
      payload.created_after = this.requestOptions.created_after;
    }
    if (this.requestOptions.created_before) {
      payload.created_before = this.requestOptions.created_before;
    }
    this.store.dispatch(new ExportPost(payload));
  }

  getAllReportsData() {
    const request = FilterHelpers.GetPostRequestOptions(this.selectedFilters);
    this.requestOptions.created_after = request.startDate;
    this.requestOptions.created_before = request.endDate;
    this.requestOptions.form = this.formId;
    this.showReport = false;
    this.postService.list(this.requestOptions).subscribe(results => {
      this.posts = { count: 0, results: [] };
      if (results && results.count > 0) {
        this.posts = results;
        this.getFormattedData();
      }
      this.showReport = true;
    });
  }

  scrollWindow() {
    setTimeout(() => {
      window.scrollTo(0, 1200);
    }, 200);
  }

  validarField(event: KeyboardEvent) {
		const char = event.key;
		const regex = /^[a-zA-Z0-9áéíóúÁÉÍÓÚñÑ\s\-_@.+]$/;
		if (!regex.test(char)) {
			event.preventDefault();
		}
	} 
}
